import { parseEntities } from '@amzn/awscat-editor';
import EnvironmentConfig from '../../common/EnvironmentConfig';

export const loadEntities = async () => {
  const envConfig = EnvironmentConfig.getConfig();
  const payloadResponse: Response = await fetch(envConfig.entitiesEndpoint ?? '');
  if (payloadResponse.status < 400) {
    const payload = await payloadResponse.json();
    return parseEntities(payload.entities);
  }
  return undefined;
};
